import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { InputBox } from "../../Common";
import Button from "../../Common/Button";
import styles from "./beneficiary.module.css";
import { mcbAddBeneficiary } from "../../api";
import { validateForm } from "../../utils/validation";

function CreateBeneficiary({ userId, onSuccess, onCancel }) {
  const initialFormData = {
    firstName: "",
    lastName: "",
    bankName: "",
    streetAddress: "",
    accountNo: "",
    accountRoutingValue: "",
    swiftCode: "",
    city: "",
    state: "",
    postcode: "",
    country: "",
    accountCurrency: "",
  };

  const [formData, setFormData] = useState(initialFormData);
  const [loading, setLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const [successMessage, setSuccessMessage] = useState("");

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({ ...prevData, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const requiredFields = Object.keys(initialFormData);
    setErrors({});
    
    if (validateForm(requiredFields, setErrors, formData)) {
      setLoading(true);
      try {
        const beneficiaryData = {
          ...formData,
          userId: userId,
        };
        
        const response = await mcbAddBeneficiary(beneficiaryData);
        
        if (response.status === 200 && response.data) {
          
          setSuccessMessage("Beneficiary created successfully!");
          setFormData(initialFormData);
          setTimeout(() => {
            onSuccess(response.data);
            setSuccessMessage("");
          }, 3000);
        } else if (response.status === 422) {
          setErrors({ submit: response.data.message || "Beneficiary already exists" });
        } else {
        let errorData = response.data.error || response.data.message || "Failed to create beneficiary.";
        if (Array.isArray(errorData)) {
          setErrors({ submit: errorData });
        } else {
          setErrors({ submit: [errorData] });
        }
      }
      } catch (error) {
        setErrors({ submit: error?.response?.data?.message || "Error creating beneficiary." });
      } finally {
        setLoading(false);
      }
    }
  };

  return (
    <div className={styles.beneficiaryForm}>
      <form onSubmit={handleSubmit}>
        <Row style={{ margin: "20px 0px", width: "100%" }}>
           <Col md={6} className={styles.inputDiv}>
            <label>
              First Name <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter First Name"
                type="text"
                name="firstName"
                onChange={handleChange}
                value={formData.firstName}
              />
              {errors.firstName && (
                <p className={styles.errorMessage}>{errors.firstName}</p>
              )}
            </label>
          </Col>
           <Col md={6} className={styles.inputDiv}>
            <label>
              Last Name <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Last Name"
                type="text"
                name="lastName"
                onChange={handleChange}
                value={formData.lastName}
              />
              {errors.lastName && (
                <p className={styles.errorMessage}>{errors.lastName}</p>
              )}
            </label>
          </Col>
          <Col md={6} className={styles.inputDiv}>
            <label>
              Bank Name <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Bank Name"
                type="text"
                name="bankName"
                onChange={handleChange}
                value={formData.bankName}
              />
              {errors.bankName && (
                <p className={styles.errorMessage}>{errors.bankName}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Account Number <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Account Number"
                type="text"
                name="accountNo"
                onChange={handleChange}
                value={formData.accountNo}
              />
              {errors.accountNo && (
                <p className={styles.errorMessage}>{errors.accountNo}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Street Address <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Street Address"
                type="text"
                name="streetAddress"
                onChange={handleChange}
                value={formData.streetAddress}
              />
              {errors.streetAddress && (
                <p className={styles.errorMessage}>{errors.streetAddress}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Account Routing Value <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Account Routing Value"
                type="text"
                name="accountRoutingValue"
                onChange={handleChange}
                value={formData.accountRoutingValue}
              />
              {errors.accountRoutingValue && (
                <p className={styles.errorMessage}>{errors.accountRoutingValue}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              SWIFT Code <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter SWIFT Code"
                type="text"
                name="swiftCode"
                onChange={handleChange}
                value={formData.swiftCode}
              />
              {errors.swiftCode && (
                <p className={styles.errorMessage}>{errors.swiftCode}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              City <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter City"
                type="text"
                name="city"
                onChange={handleChange}
                value={formData.city}
              />
              {errors.city && (
                <p className={styles.errorMessage}>{errors.city}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              State <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter State"
                type="text"
                name="state"
                onChange={handleChange}
                value={formData.state}
              />
              {errors.state && (
                <p className={styles.errorMessage}>{errors.state}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Postcode <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Postcode"
                type="text"
                name="postcode"
                onChange={handleChange}
                value={formData.postcode}
              />
              {errors.postcode && (
                <p className={styles.errorMessage}>{errors.postcode}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Country <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Country Code"
                type="text"
                name="country"
                onChange={handleChange}
                value={formData.country}
              />
              {errors.country && (
                <p className={styles.errorMessage}>{errors.country}</p>
              )}
            </label>
          </Col>

          <Col md={6} className={styles.inputDiv}>
            <label>
              Account Currency <span className={styles.required}>*</span>
              <InputBox
                placeholder="Enter Account Currency"
                type="text"
                name="accountCurrency"
                onChange={handleChange}
                value={formData.accountCurrency}
              />
              {errors.accountCurrency && (
                <p className={styles.errorMessage}>{errors.accountCurrency}</p>
              )}
            </label>
          </Col>
        </Row>

        {successMessage && (
          <div style={{ textAlign: "center", color: "green", margin: "20px" }}>
            {successMessage}
          </div>
        )}
        {errors.submit && (
        <div style={{ textAlign: "center", color: "red", margin: "20px" }}>
          {errors.submit.map((err, index) => (
            <div key={index}>{err}</div>
          ))}
        </div>
      )}

        <Row style={{ margin: "20px 0px", width: "100%" }}>
          <Col md={6} className={styles.inputDiv}>
            <Button 
              onClick={handleSubmit} 
              title={"Add Beneficiary"}
              loading={loading}
              disabled={loading}
            />
          </Col>
        </Row>
      </form>
    </div>
  );
}

export default CreateBeneficiary;